/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import { FC, ReactElement } from 'react';

import { FlexStyled } from '../../../Block/Flexbox';
import { EChartDataKeyEnum, IChartDataInput } from '../../chartTypes';
import { ChartDynamicLabelStyled, ChartDynamicLabelTextStyled } from './styled/ChartDynamicLabelStyled';

export interface IChartDynamicLabelProps {
    item: IChartDataInput;
}

export const ChartDynamicLabel: FC<IChartDynamicLabelProps> = props => {
    const values: string[] = Object.keys(props.item[EChartDataKeyEnum.y]);
    const labels: string[] = [];
    if (values.length > 0) {
        labels.push(values[0]);
    }
    if (values.length > 2) {
        if (values.length % 2 === 0) {
            const labelLeftIndex = Math.round(values.length * 0.33);
            const labelRightIndex = Math.floor(values.length * 0.66);
            labels.push(values[labelLeftIndex]);
            labels.push(values[labelRightIndex]);
        } else {
            const labelMiddleIndex = Math.floor(values.length * 0.5);
            labels.push(values[labelMiddleIndex]);
        }
    }
    if (values.length > 1) {
        labels.push(values[values.length - 1]);
    }
    return (
        <ChartDynamicLabelStyled>
            {
                labels.map((date: string): ReactElement => {
                    return (
                        <FlexStyled className="chart-line__label-item" key={date}>
                            <ChartDynamicLabelTextStyled>
                                {date}
                            </ChartDynamicLabelTextStyled>
                        </FlexStyled>
                    );
                })
            }
        </ChartDynamicLabelStyled>

    );
};

export default ChartDynamicLabel;
